module.exports = __webpack_public_path__ + "static/media/map-pin-icon.e495fd48.svg";